import React from 'react';

import Dialog from 'sharedreact/components/Dialog';
import SessionWarningMode from 'sharedreact/constants/SessionWarningMode';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  language: string,
  mode: number,
  
  onExtendSession: () => void,
  onClose: () => void
};

type State = {
  show: boolean,
  confirmed: boolean
};

class SessionWarningDialog extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      show: (
        props.mode === SessionWarningMode.WillExpire ||
        props.mode === SessionWarningMode.Expired
      ),
      confirmed: false
    }

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  updateShow (show: boolean): void {
    this.setState({show: show});
  }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    if (this.props.mode !== prevProps.mode) {
      if (this.props.mode === SessionWarningMode.WillExpire ||
        this.props.mode === SessionWarningMode.Expired) {
        if (prevProps.mode !== SessionWarningMode.WillExpire &&
          prevProps.mode !== SessionWarningMode.Expired) {
          this.updateShow(true);
        }
      } else {
        this.updateShow(false);
      }
    }
  }

  handleConfirm (): void {
    const {
      mode,
      onExtendSession,
      onClose
    } = this.props;

    this.setState({show: false, confirmed: true});

    if (mode === SessionWarningMode.Expired) {
      onClose();
    } else if (mode === SessionWarningMode.WillExpire) {
      onExtendSession();
    }
  }

  handleClose (): void {
    const {
      onClose
    } = this.props;

    this.setState({show: false, confirmed: false});

    onClose();
  }

  
  override render (): React.ReactNode {
    const {
      language, mode
    } = this.props;

    let title: string = '';
    let message: string = '';
    let confirmButtonText: string = '';

    if (mode === SessionWarningMode.Expired) {
      title = translate('shared.sessionwarning.expired.title');
      message= translate('shared.sessionwarning.expired.info');
      confirmButtonText = translate('shared.sessionwarning.button.ok');
    } else if (mode === SessionWarningMode.WillExpire) {
      title = translate('shared.sessionwarning.willexpire.title');
      message= translate('shared.sessionwarning.willexpire.info');
      confirmButtonText = translate('shared.sessionwarning.button.extend');
    }

    return (
      <Dialog
        id='ae_dialog_sessionwarning'
        show={this.state.show}
        zIndex={2000}
        title={title}
        language={language}
        hideCloseButton
        confirmText={confirmButtonText}
        onConfirm={this.handleConfirm}
        onClose={this.handleClose}
      >
        {message}
      </Dialog>
    );
  }
}

export default SessionWarningDialog;
